function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 29.94c8.288 0 15-6.444 15-14.4s-6.712-14.4-15-14.4c-8.287 0-15 6.444-15 14.4s6.713 14.4 15 14.4z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 26.016a.217.217 0 01-.125-.036L7.85 21.756a.328.328 0 01-.088-.096c-.012-.012-.012-.036-.012-.048a.128.128 0 010-.096v-.012l2.287-10.044c.013-.036.025-.06.038-.096l4.737-6.204a.265.265 0 01.2-.096c.075 0 .15.036.2.096l4.738 6.204c.025.024.037.06.037.096l2.288 10.044v.108a.09.09 0 01-.025.048.286.286 0 01-.088.084l-7.025 4.224a.214.214 0 01-.137.048zm-6.2-4.224l5.762 3.468-1.15-3.468H8.8zm7.775 0l-1.15 3.468 5.762-3.468h-4.612zm-2.65 0L15 25.044l1.075-3.252h-2.15zm2.812-.468h4.888L18.5 16.02l-1.763 5.304zm-2.962 0h2.462l1.938-5.844L15 10.116l-3.175 5.376 1.95 5.832zm-5.4 0h4.887L11.5 16.02l-3.125 5.304zm10.312-5.892l2.763 4.692-1.763-7.728-1 3.036zM10.3 12.396l-1.763 7.728 2.763-4.692-1-3.036zm4.937-2.808l3.125 5.292 1.113-3.336L15.237 6v3.588zm-4.712 1.956l1.112 3.336 3.125-5.292V6l-4.237 5.544z",
  fill: "#fff"
});

function SvgEos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "b61cba4bb1f79d382e1f62af4b08d7da.svg";
export { SvgEos as ReactComponent };